import { createAction, props } from '@ngrx/store';
import { ClinicalCase } from 'src/app/sdk-api';

const name = 'ClinicalCase';

export namespace ClinicalCaseActions {
  export const reset = createAction(`[${name}] Reset Clinical Case`);
  export const getEntity = createAction(`[${name}] Get Clinical Case`);
  export const setEntity = createAction(
    `[${name}] Set Clinical Case`,
    props<{
      clinicalCase: ClinicalCase;
    }>(),
  );
}
